import { handleServerErrors, persistentHandler } from '../../registration/util/error';
import { PATH } from './paths';
import { dispatch } from 'nike-re-framejs';
import { set2FAError } from '../index';

/**
 * kazda chyba okrem WRONG_CODE ukoncuje 2FA proces a otvara FAILED stranku
 */
export default function handleError2FA(form) {
    return handleServerErrors(form, {
        codeHandlers: {
            WRONG_CODE: persistentHandler(PATH.SMS_CODE, 'validation.smscode.wrong')
        },
        uiWrapper: a => a,
        finalHandler: error => {
            let code = error?.response?.data?.code;
            code = whitelistCodes.includes(code) ? code : 'UNEXPECTED';
            dispatch(set2FAError(code));
        }
    });
}

/**
 * (whitelist) zoznam chyb ktore ideme klientovi prekladat
 */

const whitelistCodes = [
    'GRID_CARD_NOT_IMPORTED',
    'CLIENT_GRID_CARD_MISSING',
    'CLIENT_EMAIL_NOT_SET',
    'WRONG_GRID',
    'BLOCKED_GRID',
    'TOO_MANY_RETRIES',
    'BLOCKED_CODE',
    'TIME_LIMIT_REACHED'
];
